import { Form, Formik } from "formik";
import { handleSubmitForm } from "helpers/apiUtils";
import { Row, Col } from "react-bootstrap";
import React, {  useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  updateMpinSchema,
} from "utils/validations";
import CustomField from "components/form/CustomField";
import { usePermission } from "hooks/usePermission";
import { updateMpin } from "store/slices/usersSlice";
import { showAlert } from "store/slices/alertSlice";

function UpdateMpin({ updatingUserId,setShowOptionsModal, onSuccess = () => {} }) {
  const {
    t,
  } = useTranslation();
  const dispatch = useDispatch();
  const { canAction } = usePermission();

  const [initialValues, setInitialValues] = useState({
    id :updatingUserId,
    mpin: ""
  });
    const { isLoading } = useSelector((state) => state.Users);
  

  const handleSubmitChangePassword = (values) => {
    const payload = {
      ...initialValues,
      mpin: values.mpin,
    };

    handleSubmitForm({
      dispatch,
      action: updateMpin,
      payload,
      onSuccess: () => {
        onSuccess();
        dispatch(
          showAlert({
            text: t(`Mpin updated successfully`),
            type: "success",
          }),
        );
      },
    });
  };

  return (
    <div className="common_modal_card change_password">
      <div className="heading mb-2">
        <h2>{t("Update Mpin")}</h2>
      </div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={updateMpinSchema(t)}
        onSubmit={handleSubmitChangePassword}
      >
        {() => (
          <Form>
            <Row>
              <Col lg={12}>
                <div className="form_field position-relative">
                  <CustomField
                    name="mpin"
                    type={"text"}
                    label={t("Mpin")}
                    placeholder={t("Enter mpin")}
                  />
                </div>
              </Col>
              

              <Col lg={12} className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="main_btn outline"
                  onClick={() => {
                    setShowOptionsModal(false);
                  }}
                >
                  {t("Cancel")}
                </button>

                <button type="submit" className="main_btn" disabled={isLoading}>
                  {t("Save Changes")}
                </button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default UpdateMpin;
